import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import { Key } from "readline";
interface ITreeDs<T> {
    enable?: number;
    code?: string;
    children?: T[]
}

export interface ITreeData<T> {
    key: Key;
    title?: string;
    children?: ITreeData<T>[] | undefined;
}

export interface IFieldValue<T> {
    [key: string]: T[keyof T]
}
export function trasDsToTreeData<T extends ITreeDs<T>>(
    ds: T[],
    keyField: keyof T,
    titleField: keyof T,
): ITreeData<T>[] {
    return ds.map(el => {
        const key = el[keyField] as any;
        const title = el[titleField] as any;
        const children = el.children && el.children.length > 0 ? trasDsToTreeData(el.children, keyField, titleField) : undefined;
        const disabled = el.enable === 0;
        return {
            el,
            key,
            title,
            disabled,
            value: el["code"],
            selectable: !disabled,
            children,
        }
    });
}
export interface ISCMDictSearch {
    page: {
        pageSize: number;
        pageNum: number;
    },
    sourceApp?: string;
    branch?: string
}

export interface ISCMDictDetail {
    // note: string,
    // ver: number,
    // code: string,
    // sourceAuthKey: string,
    // pcode: string | null,
    // children: ISCMDictDetail[],
    // enable: number,
    // name: string,
    // branch: string,
    // value: string,
    // key: string,

    branch: string,
    branchList: any | null,
    ver: number,
    enable: number,
    dictType: null,
    code: string,
    name: string,
    nameEn: string | null,
    value: string,
    pcode: string | null,
    note: string,
    status: number,
    children: ISCMDictDetail[],
    key: string,
    sign?: string,
}

export interface ISCMDictInsert {
    sourceApp: string,
    branch?: string,
    code: string,
    name: string,
    value?: string,
    pcode?: string | null,
    note?: string,
}
export interface ISCMDictUpdate {
    sourceApp: string,
    branch?: string,
    code: string,
    value?: string,
}

export interface ISCMDictOne {
    sourceApp: string,
    branch?: string,
    code: string
}

class DictService {
    //树列表
    async page(searchVo: ISCMDictSearch) {
        const apiUrl = "/vrm-sa/base/dict/page";
        return await httpRequest.post<IPage<ISCMDictDetail>>(apiUrl, searchVo)
    }
    //新增
    async insert(insertVo: ISCMDictInsert) {
        const apiUrl = "/vrm-sa/base/dict/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    //编辑
    async update(updateVo: ISCMDictUpdate) {
        const apiUrl = "/vrm-sa/base/dict/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    //新增
    async insertLocal(insertVo: object) {
        const apiUrl = "/vrm-sa/base/dict/insertLocal";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    //编辑
    async updateLocal(updateVo: object) {
        const apiUrl = "/vrm-sa/base/dict/updateLocal";
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    //获取一条
    async one(oneVo: ISCMDictOne) {
        const apiUrl = "/vrm-sa/base/dict/one";
        return await httpRequest.post<ISCMDictDetail>(apiUrl, oneVo)
    }

    async disable(oneVo: ISCMDictOne) {
        const apiUrl = "/vrm-sa/base/dict/disable";
        return await httpRequest.post<boolean>(apiUrl, oneVo)
    }

    async remove(oneVo: ISCMDictOne) {
        const apiUrl = "/vrm-sa/base/dict/remove";
        return await httpRequest.post<boolean>(apiUrl, oneVo)
    }
}

export const dictService = new DictService();
